import { render } from "./support-view.vue?vue&type=template&id=76f6c1bd"
import script from "./support-view.vue?vue&type=script&setup=true&lang=js"
export * from "./support-view.vue?vue&type=script&setup=true&lang=js"

import "./support-view.vue?vue&type=style&index=0&id=76f6c1bd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/support/support-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76f6c1bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76f6c1bd', __exports__)) {
    api.reload('76f6c1bd', __exports__)
  }
  
  module.hot.accept("./support-view.vue?vue&type=template&id=76f6c1bd", () => {
    api.rerender('76f6c1bd', render)
  })

}


export default __exports__